import { renderMainLeftCell, renderSoftLeftCell, renderSectionHeader, renderRowGaps, renderColumnGaps, renderPercentRow, renderMainRightCell } from '../helpers';
import { textBold, percentSingleDecimal } from '../download-data-styles';

export const renderBondBreakdownHeaderRow = (title, asOfdate) => {
  let rowString = `<tr>`;
  rowString += renderMainLeftCell(title, textBold);
  rowString += renderSoftLeftCell(asOfdate);
  rowString += `</tr>`;
  return rowString;
};

export const renderBondSubtypeRow = (label, value) => {
  let rowString = `<tr>`;
  rowString += renderColumnGaps();
  rowString += renderMainLeftCell(label);
  rowString += renderMainRightCell(`${value}%`, percentSingleDecimal);
  rowString += `</tr>`;
  return rowString;
};

export const bondsBreakdownModule = data => {
  let bondString = ``;
  bondString += renderSectionHeader('Bonds Breakdown');
  bondString += renderRowGaps();
  bondString += renderBondBreakdownHeaderRow('Bond Details', data.bondDetailAsOfDate);
  bondString += renderRowGaps();
  data.bonds.data.forEach(holding => {
    bondString += renderPercentRow(holding.label, holding.value);
    holding.subType.forEach(category => {
      bondString += renderBondSubtypeRow(category.name, category.value);
    });
  });
  bondString += renderRowGaps();
  bondString += renderBondBreakdownHeaderRow(data.topIssuersLabel, data.topIssuersAsOfDate);
  bondString += renderRowGaps();
  data.topIssuers.data.forEach(issuer => {
    bondString += renderPercentRow(issuer.SubTypeName, issuer.DataValue);
  });
  bondString += renderColumnGaps(2);
  return bondString;
};
